module.exports = __webpack_public_path__ + "img/excepcional.903f0e4b.png";